import { render, staticRenderFns } from "./UserReasonExistedModal.vue?vue&type=template&id=06f1be0c"
import script from "./UserReasonExistedModal.vue?vue&type=script&lang=js"
export * from "./UserReasonExistedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports